import { isBefore, isSameDay } from 'date-fns'

/** Converte ISO / Date para valor de input datetime-local (fuso local). */
export function toDatetimeLocalValue(value?: string | Date) {
  if (!value) return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const offset = date.getTimezoneOffset()
  const local = new Date(date.getTime() - offset * 60_000)
  return local.toISOString().slice(0, 16)
}

export function parseDatetimeLocal(value: string): Date | null {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatDatetimeLocal(date: Date): string {
  return toDatetimeLocalValue(date)
}

export function roundToNextMinutes(date: Date, step = 15): Date {
  const next = new Date(date)
  const minutes = next.getMinutes()
  const rounded = Math.ceil(minutes / step) * step
  if (rounded >= 60) {
    next.setHours(next.getHours() + 1, 0, 0, 0)
  } else {
    next.setMinutes(rounded, 0, 0)
  }
  return next
}

/** Alinha minutos ao grid de 5 em 5 (usado pelo seletor de hora). */
export function snapMinutesToStep(date: Date, step = 5): Date {
  const next = new Date(date)
  const minutes = next.getMinutes()
  next.setMinutes(minutes - (minutes % step), 0, 0)
  return next
}

export function minAllowedDate(min?: string): Date | null {
  if (!min) return null
  return parseDatetimeLocal(min)
}

export function isHourOptionDisabled(draft: Date, hour: number, minDate: Date | null): boolean {
  if (!minDate || !isSameDay(draft, minDate)) return false
  return hour < minDate.getHours()
}

export function isMinuteOptionDisabled(draft: Date, minute: number, minDate: Date | null): boolean {
  if (!minDate || !isSameDay(draft, minDate)) return false
  if (draft.getHours() > minDate.getHours()) return false
  if (draft.getHours() < minDate.getHours()) return true
  return minute < minDate.getMinutes()
}

export function clampDraftToMin(draft: Date, minDate: Date | null): Date {
  if (!minDate || !isBefore(draft, minDate)) return snapMinutesToStep(draft)
  return snapMinutesToStep(minDate)
}

export const PAST_MEETING_DATETIME_MESSAGE =
  'Não é possível marcar reunião para horários que já passaram.'
